import React from 'react';
import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';
import { PostHogProvider } from '@posthog/react';
import { posthogOptions } from '@posthog-app/posthog-config';
import { isProductionMode } from '@utils/get-environment/get-environment';

import { App } from './app';
import { i18nInitPromise } from './i18n';

import './index.css';

const POSTHOG_TOKEN = import.meta.env.VITE_POSTHOG_TOKEN as string | undefined;

const container = document.getElementById('root');
const root = createRoot(container as HTMLElement);

const renderApp = () => {
  root.render(
    POSTHOG_TOKEN ? (
      <PostHogProvider apiKey={POSTHOG_TOKEN} options={posthogOptions}>
        <App />
      </PostHogProvider>
    ) : (
      <App />
    )
  );
};

i18nInitPromise.then(() => {
  if (isProductionMode) {
    renderApp();
  } else {
    import('@axe-core/react').then((axe) => {
      axe.default(React, ReactDOM, 1000);
      renderApp();
    });
  }
});
